import React from 'react'

export const idahoSetupVars = {
  siteId: 'idaho',
  pathPrefix: '/id',
  menuHeader: "Discover Idaho's Solution for:",
  appUrl: 'https://id.headed2.com',
  logoImg: '/images/assets/idaho/horizontal/dark.svg',
  headerTitle: `The Idaho CareerExplorer is a system designed for Idaho`
}
